import { tickerList } from "@/mocks/guaNews";

export default function Hero() {
  const dateStr = "2026年9月6日 星期日";
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200/70 bg-background-100">
      {/* decorative lines */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.5]">
        <div className="absolute -top-24 -right-20 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl"></div>
        <div className="absolute -bottom-24 -left-16 h-64 w-64 rounded-full bg-secondary-100/70 blur-3xl"></div>
      </div>

      <div className="relative mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-16">
        <div className="grid items-center gap-8 lg:grid-cols-[1.1fr_0.9fr]">
          {/* copy */}
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-flashlight-fill text-sm"></i>
                今日吃瓜 · 全网速览
              </span>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-600">
                <i className="ri-calendar-line text-sm"></i>
                {dateStr}
              </span>
            </div>

            <h2 className="mt-5 font-heading text-3xl font-black leading-[1.2] text-foreground-950 md:text-5xl">
              五1吃瓜<span className="text-primary-600">今日爆料</span>
              <br />
              一手掌握
            </h2>
            <p className="mt-5 max-w-xl text-[15px] leading-7 text-foreground-600">
              今日爆料与最新瓜同步更新，热门<strong className="font-semibold text-foreground-800">爆料合集</strong>持续汇总，新料第一时间看到。
              想快速吃饱今天的瓜，不用到处翻帖子，看这一页就够了。
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#board"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-fire-fill text-base"></i>
                查看今日热搜
              </a>
              <a
                href="#collection"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 ring-1 ring-inset ring-background-300/60 transition-colors hover:bg-background-100"
              >
                <i className="ri-folder-chart-line text-base text-accent-700"></i>
                逛爆料合集
              </a>
            </div>

            <dl className="mt-8 grid max-w-md grid-cols-3 gap-3">
              {[
                { k: "今日新增", v: "128+" },
                { k: "专题合集", v: "36" },
                { k: "全网专区", v: "6 大区" },
              ].map((s) => (
                <div key={s.k} className="rounded-lg bg-background-50 px-3 py-3 ring-1 ring-inset ring-background-200/70">
                  <dt className="text-xs text-foreground-500">{s.k}</dt>
                  <dd className="mt-1 font-heading text-xl font-bold text-foreground-950">{s.v}</dd>
                </div>
              ))}
            </dl>
          </div>

          {/* hero visual */}
          <div className="relative">
            <div className="overflow-hidden rounded-2xl ring-1 ring-inset ring-background-200/80">
              <img
                src="https://readdy.ai/api/search-image?query=cinematic%20editorial%20collage%20of%20entertainment%20news%20gossip%20with%20floating%20headlines%20cards%2C%20popcorn%20and%20ticket%20stubs%20on%20cream%20table%2C%20warm%20amber%20and%20watermelon%20red%20accents%2C%20clean%20modern%20magazine%20layout%2C%20soft%20studio%20lighting%2C%20minimal%20elegant%20composition&width=1000&height=720&seq=gua-hero-2026&orientation=landscape"
                alt="五1吃瓜今日爆料合集主视觉"
                className="h-[300px] w-full object-cover md:h-[400px]"
              />
            </div>
            <div className="absolute -bottom-4 left-1/2 flex w-max -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-xs font-medium text-background-50 shadow-sm">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-400"></span>
              </span>
              新料持续更新中 · 关注不迷路
            </div>
          </div>
        </div>
      </div>

      {/* ticker */}
      <div className="relative border-t border-background-200/70 bg-background-50/80">
        <div className="mx-auto flex max-w-6xl items-center gap-4 px-4 py-3 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-bold text-primary-700">
            <i className="ri-flashlight-fill text-sm"></i>
            快讯滚动
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track flex w-max items-center gap-8">
              {[...tickerList, ...tickerList].map((t, i) => (
                <span key={i} className="whitespace-nowrap text-sm text-foreground-600">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}